



























































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { TYPES } from "@/constants/booking"
import BookingCandidateReadPolicy from "./BookingCandidateReadPolicy.vue"
import BookingCandidateReadDetails from "./BookingCandidateReadDetails.vue"
import BookingCandidateReadQuestionnaireProgress from "./BookingCandidateReadQuestionnaireProgress.vue"
import BookingCandidateReadQuestionnaireResult from "./BookingCandidateReadQuestionnaireResult.vue"
import BookingCandidateReadServiceOrderDetails from "./BookingCandidateReadServiceOrderDetails.vue"

@Component({
  components: {
    BookingCandidateReadPolicy,
    BookingCandidateReadDetails,
    BookingCandidateReadQuestionnaireProgress,
    BookingCandidateReadQuestionnaireResult,
    BookingCandidateReadServiceOrderDetails,
  },
  computed: {
    ...mapState("Auth", {
      candidate: "candidate",
      user: "user",
    }),
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate",
    }),
  },
})
export default class BookingCandidateRead extends Vue {
  // candidate State
  candidate!: Model
  user!: Model
  // bookingCandidate State
  bookingCandidate!: BookingCandidate
  types = TYPES
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES

  isMounted = false

  isPaying = false
  retryCount = 0
  timer: NodeJS.Timeout | null = null

  title() {
    return (
      "Welcome, <span class='secondary--text'>" + this.user.name + "</span>"
    )
  }

  beforeMount() {
    this.init()
  }

  get showDetails() {
    if (
      this.bookingCandidate.status &&
      [
        this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
        this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
        this.bookingCandidateStatuses.STATUS_COMPLETED.key,
        this.bookingCandidateStatuses.STATUS_CANCEL.key,
        this.bookingCandidateStatuses.STATUS_EXCEPTION.key,
      ].includes(this.bookingCandidate.status)
    ) {
      return true
    }
    return false
  }

  get showQuestionnaireProgress() {
    if (
      this.bookingCandidate.status &&
      [
        this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
        this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
      ].includes(this.bookingCandidate.status)
    ) {
      return true
    }
    return false
  }

  get showPaymentDetails() {
    if (this.bookingCandidate.booking.type == this.types.CANDIDATE_PAY) {
      if (
        this.bookingCandidate.status && 
        [
          this.bookingCandidateStatuses.STATUS_AWAIT_PAYMENT.key,
          this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
          this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
          this.bookingCandidateStatuses.STATUS_COMPLETED.key,
        ].includes(this.bookingCandidate.status)
      ) {
        return true
      }
    }
    return false
  }

  get showResult() {
    if (
      this.bookingCandidate.status &&
      [
        this.bookingCandidateStatuses.STATUS_COMPLETED.key,
      ].includes(this.bookingCandidate.status)
    ) {
      return true
    }
    return false
  }

  async init() {
    this.retryCount = 0
    this.isPaying = true
    while (this.retryCount < 5) {
      await this.$store.dispatch(
        "BookingCandidate/fetch",
        this.$route.params.bookingCandidateOid
      )
      if (
        this.bookingCandidate.status &&
        ![
          this.bookingCandidateStatuses.STATUS_AWAIT_RESULT.key,
        ].includes(
          this.bookingCandidate.status
        )
      ) {
        console.debug(this.bookingCandidate.status)
        console.debug(this.bookingCandidateStatuses.STATUS_AWAIT_PAYMENT.key)
        break
      }
      await this.wait(3000)
      this.retryCount += 1
    }
    this.timer = null
    this.isPaying = false
    this.isMounted = true
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.timer = setTimeout(resolve, ms)
    })
  }

  paid() {
    this.init()
  }
}
